const i18n = {
  steps: {
    1: {
      title: {
        de: 'Schritt 1',
        fr: 'Étape 1',
        it: 'Passo 1',
      },
      subTitle: {
        de: 'Beteiligte Akteure',
        fr: 'Acteurs impliqués',
        it: 'Attori coinvolti',
      },
    },
    2: {
      title: {
        de: 'Schritt 2',
        fr: 'Étape 2',
        it: 'Passo 2',
      },
      subTitle: {
        de: 'Allgemeine Angaben zum Projekt',
        fr: 'Informations générales sur le projet',
        it: 'Informazioni generali sul progetto',
      },
    },
    3: {
      title: {
        de: 'Schritt 3',
        fr: 'Étape 3',
        it: 'Passo 3',
      },
      subTitle: {
        de: 'Projektkosten',
        fr: 'Coûts du projet',
        it: 'Costi del progetto',
      },
    },
    4: {
      title: {
        de: 'Schritt 4',
        fr: 'Étape 4',
        it: 'Passo 4',
      },
      subTitle: {
        de: 'Projektfinanzierung',
        fr: 'Financement du projet',
        it: 'Finanziamento del progetto',
      },
    },
    5: {
      title: {
        de: 'Schritt 5',
        fr: 'Étape 5',
        it: 'Passo 5',
      },
      subTitle: {
        de: 'Weitere Informationen',
        fr: 'Informations complémentaires',
        it: 'Informazioni addizionali',
      },
    },
  },
  actions: {
    detailsInfo: {
      de: 'Detailinformationen',
      fr: 'Informations détaillées',
      it: 'Informazioni dettagliate',
    },
    cancel: {
      de: 'Abbrechen',
      fr: 'Annuler',
      it: 'Cancella',
    },
    nextStep: {
      de: 'Nächste Seite',
      fr: 'Page suivante',
      it: 'Pagina seguente',
    },
    prevStep: {
      de: 'Vorherige Seite',
      fr: 'Page précédente',
      it: 'Pagina precedente',
    },
    send: {
      de: 'Abschicken',
      fr: 'Envoyer',
      it: 'Invia',
    },
  },
  requestingOrganisation: {
    de: 'Antragstellende Organisation',
    fr: 'Organisation requérante',
    it: 'Organizzazione richiedente',
    placeholder: {
      de: 'Organisation',
      fr: 'Organisation',
      it: 'Organizzazione',
    },
  },
  responsiblePerson: {
    de: 'Gesamtverantwortliche/r des Projekts',
    fr: 'Responsable global pour le projet',
    it: 'Responsabile generale del progetto',
    placeholder: {
      de: 'Projektleiter/in',
      fr: 'Responsable pour le projet',
      it: 'Responsabile del progetto',
    },
  },
  responsiblePersonEmail: {
    de: 'E-Mail',
    fr: 'E-mail',
    it: 'E-mail',
  },
  responsiblePersonPhone: {
    de: 'Telefonnummer',
    fr: 'N° de téléphone',
    it: 'N. telefono',
  },
  employees: {
    de: 'Einsatz von Mitarbeitenden',
    fr: 'Engagement de collaborateurs',
    it: 'Impiego di personale',
    fullName: {
      de: 'Name, Vorname',
      fr: 'Nom, prénom',
      it: 'Nome, cognome',
    },
    organisation: {
      de: 'Organisation',
      fr: 'Organisation',
      it: 'Organizzazione',
    },
    function: {
      de: 'Funktion',
      fr: 'Fonction',
      it: 'Funzione',
    },
    signedContract: {
      de: 'Unterzeichnung Vertrag',
      fr: 'Signature du contrat',
      it: 'Sottoscrizione del contratto',
    },
  },
  projectPartners: {
    de: 'Weitere Projektpartner',
    fr: 'Autres partenaires de projet du requérant',
    it: 'Altri partner di progetto del(la) richiedente',
    organisationName: {
      de: 'Organisation',
      fr: 'Organisation',
      it: 'Organizzazione',
    },
    zipCode: {
      de: 'Postleitzahl',
      fr: 'NPA',
      it: 'NPA',
    },
    location: {
      de: 'Ort',
      fr: 'Localité',
      it: 'Località',
    },
    street: {
      de: 'Strasse',
      fr: 'Rue',
      it: 'Via',
    },
    houseNumber: {
      de: 'Hausnummer',
      fr: 'No de rue',
      it: 'Numero di via',
    },
    lastName: {
      de: 'Name',
      fr: 'Nom',
      it: 'Nome',
    },
    firstName: {
      de: 'Vorname',
      fr: 'Prénom',
      it: 'Cognome',
    },
  },
  projectManager: {
    de: 'Projektbegleiter/in BFE',
    fr: 'Responsable du projet OFEN',
    it: 'Responsabile del progetto UFE',
    placeholder: {
      de: 'Projektbegleiter/in',
      fr: 'Responsable du projet',
      it: 'Responsabile del progetto',
    },
    tooltip: {
      de: 'Falls bekannt',
      fr: 'Si connu',
      it: 'Se noto',
    },
  },
  topic: {
    de: 'Handlungsfeld / Thema des Projekts',
    fr: 'Champ d’action / thème du projet',
    it: "Campo d'azione / tema del progetto",
    options: {
      empty: {
        de: 'Bitte wählen ...',
        fr: 'Veuillez choisir ...',
        it: 'Si prega di selezionare ...',
      },
      efficiency: {
        de: 'Gebäudeeffizienz und erneuerbare Energien in privaten Haushalten',
        fr: 'Efficacité énergétique des bâtiments et énergies renouvelables destinées aux particuliers',
        it: 'Efficienza energetica degli edifici ed energie rinnovabili per le economie domestiche private',
      },
      mobility: {
        de: 'Mobilität von Privaten und Unternehmen',
        fr: 'Mobilité des ménages privés et des entreprises',
        it: 'Mobilità delle economie domenstiche private e delle aziende',
      },
      facilities: {
        de: 'Anlagen und Prozesse in Industrie und Dienstleistungen',
        fr: 'Installations et processus dans le secteur de l’industrie et des services',
        it: 'Impianti e processi in ambito industriale e nei servizi',
      },
      industry: {
        de: 'Gebäudeeffizienz und erneuerbare Energien in Industrie und Dienstleistungen',
        fr: 'Efficacité énergétique des bâtiments et énergies renouvelables dans l’industrie et les services',
        it: 'Efficienza energetica degli edifici ed energie rinnovabili in ambito industriale e nei servizi',
      },
      electro: {
        de: 'Elektrogeräte und Beleuchtungen in privaten Haushalten',
        fr: 'Appareils électriques et éclairages destinés aux particuliers',
        it: 'Apparecchi elettronici e illuminazione per le economie domestiche private',
      },
      bigfacilities: {
        de: 'Grossanlagen für erneuerbare Energien',
        fr: 'Grandes installations de production d’énergies renouvelables',
        it: 'Grandi impianti per le energie rinnovabili',
      },
      network: {
        de: 'Netze und Speicherung',
        fr: 'Réseaux et stockage',
        it: 'Reti e le strutture di stoccaggio',
      },
      education: {
        de: 'Aus- und Weiterbildung',
        fr: 'Formation et perfectionnement',
        it: 'Formazione il perfezionamento',
      },
      others: {
        de: 'Anderes Handlungsfeld/Thema',
        fr: 'Autre champ d’action / thème',
        it: 'Altro campo d’azione / tema del progetto',
      },
    },
    placeholder: {
      de: 'Handlungsfeld / Thema',
      fr: 'Champ d’action / thème',
      it: 'Campo d’azione / tema del progetto',
    },
  },
  projectTitle: {
    de: 'Titel des Projekts',
    fr: 'Nom du projet',
    it: 'Titolo del progetto',
    placeholder: {
      de: 'Kurze prägnante Bezeichnung des Projekts.',
      fr: 'Désignation brève et explicite du projet.',
      it: 'Denominazione chiara e concisa del progetto',
    },
  },
  projectDuration: {
    de: 'Projektdauer',
    fr: 'Durée du projet',
    it: 'Durata del progetto',
  },
  fromDate: {
    de: 'Projektstart',
    fr: 'Lancement prévu du projet',
    it: 'Prevista data di inizio del progetto',
  },
  toDate: {
    de: 'Projektabschluss',
    fr: 'Clôture prévue du projet',
    it: 'Prevista data di conclusione del progetto',
  },
  initialSituation: {
    de: 'Ausgangslage',
    fr: 'Situation initiale',
    it: 'Situazione di partenza',
  },
  descriptionAndProcedure: {
    de: 'Beschreibung und Vorgehen',
    fr: 'Description et procédure',
    it: 'Descrizione e procedura',
    tooltip: {
      de: 'Beschreibung des Projekts und geplante Handlungsschritte.',
      fr: 'Description du projet et des étapes d’action prévues.',
      it: 'Descrizione del progetto da sovvenzionare e delle fasi di attuazione programmate.',
    },
  },
  requirements: {
    de: 'Bedarf',
    fr: 'Besoins',
    it: 'Fabbisogno',
    placeholder: {
      de: 'Erläuterung Bedarf',
      fr: 'Explications des besoins',
      it: 'Descrizione del fabbisogno',
    },
    tooltip: {
      de: 'Erläutern Sie, weshalb es dieses Projekt braucht und geben Sie an, wie Sie zu Ihren Informationen gekommen sind.',
      fr: 'Veuillez expliquer pourquoi ce projet est nécessaire et indiquer comment vous êtes parvenu(e) à ces informations',
      it: 'Descrivete perché questo progetto è necessario e indicate come avete ottenuto le vostre informazioni.',
    },
  },
  goals: {
    de: 'Projektziele und Messung',
    fr: 'Objectifs du projet et mesure de l’atteinte des objectifs',
    it: 'Obiettivo e misurazione degli obiettivi',
    goal: {
      de: 'Projektziel (Output)',
      fr: 'Objectif du projet (Output)',
      it: 'Obiettivo del progetto (Output)',
      tooltip: {
        de: 'Was leisten Sie in welcher Anzahl für wen und bis wann? (Output)',
        fr: 'Quel est votre apport, en quelle quantité, pour qui et jusqu’à quand? (Output)',
        it: 'Quali sono le vostre prestazioni, che cosa producete, in quali quantità, per chi e fino a quando? (Output)',
      },
    },
    successIndicator: {
      de: 'Messung der Projektzielerreichung (Output)',
      fr: 'Mesure de l’atteinte de l’objectif (Output)',
      it: 'Misurazione degli obiettivi raggiunti (Output)',
      tooltip: {
        de: 'Woran erkennen und wie überprüfen Sie die Erreichung der Output-Ziele?',
        fr: 'Sur quelle base et comment vérifiez-vous que les résultats visés sont atteints? (Output)',
        it: 'Come riconoscete e controllate il raggiungimento degli obiettivi? (Output)',
      },
    },
  },
  impactsAndMeasurements: {
    de: 'Projektwirkungen und Messung',
    fr: 'Impact du projet et mesure de l’atteinte de l’impact',
    it: 'Impatto del progetto e relativa valutazione',
    impact: {
      de: 'Projektwirkungen (Outcome und Impact)',
      fr: 'Effets du projet (outcome et impact)',
      it: 'Impatti (outcome & impact) del progetto',
      tooltip: {
        de: 'Was wollen Sie bei wem, in welchem Umfang und bis wann bewirken? (Outcome und Impact)',
        fr: 'Quel effet souhaitez-vous avoir sur qui, dans quelle mesure et jusqu’à quand? (outcome et impact)',
        it: 'Quale obiettivo intendete raggiungere, in quale misura, entro quando e rispetto a chi? (outcome & impact)',
      },
    },
    successIndicator: {
      de: 'Messen der Projektwirkung (Outcome und Impact)',
      fr: 'Mesure de l’impact du projet (outcome et impact)',
      it: 'Valutazione dell’impatto del progetto (outcome & impact)',
      tooltip: {
        de: 'Woran erkennen und wie überprüfen Sie, ob Sie diesen Outcome und Impact erreichen?',
        fr: 'Sur quelle base et comment vérifiez-vous si vous obtenez l’outcome et impact souhaité?',
        it: 'Come riconoscete e controllate se avete raggiunto l’outcome & l’impatto auspicato?',
      },
    },
  },
  targetGroups: {
    de: 'Zielgruppe(n)',
    fr: 'Groupe(s) cible(s)',
    it: 'Gruppo(i) target',
    group: {
      de: 'Zielgruppe',
      fr: 'Groupe cible',
      it: 'Gruppo(i) target',
      tooltip: {
        de: 'Welche Zielgruppe(n) werden mit dem Projekt hauptsächlich angesprochen?',
        fr: 'Quel(s) groupe(s) cible(s) veut-on principalement atteindre avec ce projet?',
        it: 'A quale(i) gruppo(i) target si rivolge principalmente il progetto?',
      },
    },
    groupIdentification: {
      de: 'Ansprache der Zielgruppe',
      fr: "Manière d'entrer en contact avec le groupe cible",
      it: 'Come vi rivolgete al gruppo target?',
      tooltip: {
        de: 'Mit welchen Massnahmen werden die definierten Zielgruppen erreicht?',
        fr: 'Quelles mesures permettent-elles d’atteindre les groupes cibles définis?',
        it: 'Con quali misure vengono raggiunti i gruppi target definiti?',
      },
    },
  },
  regionCoverage: {
    de: 'Regionale Abdeckung',
    fr: 'Couverture régionale',
    it: 'Copertura regionale',
    options: {
      de: {
        de: 'Deutschschweiz',
        fr: 'Suisse allemande',
        it: 'Svizzera tedesca',
      },
      fr: {
        de: 'Westschweiz',
        fr: 'Suisse romande',
        it: 'Svizzera francese',
      },
      it: {
        de: 'Italienischsprachige Schweiz',
        fr: 'Suisse italienne',
        it: 'Svizzera di lingua italiana',
      },
    },
  },
  services: {
    de: 'Leistungen',
    fr: 'Services',
    it: 'Servizi',
  },
  internalExpenses: {
    de: 'Interne Personalkosten',
    fr: 'Coûts de personnel internes',
    it: 'Costi interni di personale',
    tooltip: {
      de: 'Die Meilensteine müssen mit einem Ergebnis verknüpft sein, welches messbar, spezifisch und zeitlich festgelegt ist. Die Kosten pro Meilenstein sowie die Gesamtprojektkosten müssen ersichtlich sein (allfällige Detailkalkullation in den Anhang).',
      fr: 'Les étapes doivent être en lien avec un résultat qui soit mesurable, spécifique et défini dans le temps. Les coûts par étape de même que les coûts totaux du projet doivent en ressortir (calcul de détail éventuel en annexe).',
      it: 'Le tappe devono essere collegate con un risultato stabilito in modo misurabile, specifico e corredato di scadenze. Nell’offerta devono figurare sia i costi relativi a ciascuna tappa che i costi complessivi del progetto (eventuale calcolo dettagliato nell’allegato).',
    },
    date: {
      de: 'Datum',
      fr: 'Date',
      it: 'Data',
    },
    milestone: {
      de: 'Meilenstein',
      fr: 'Etape',
      it: 'Tappa',
    },
    workPackage: {
      de: 'Arbeitspaket',
      fr: 'Paquet de travaux',
      it: 'Pacchetti di lavoro ',
    },
    function: {
      de: 'Funktion (Mitarbeiter/in)',
      fr: 'Fonction',
      it: 'Funzione',
    },
    hourlyRate: {
      de: 'Stundensatz (CHF/h)',
      fr: 'Tarif horaire',
      it: 'Tariffa oraria',
    },
    hourEffort: {
      de: 'Aufwand (h)',
      fr: 'Charge de travail (heures)',
      it: 'Onere (in ore)',
    },
    costs: {
      de: 'Kosten (CHF)',
      fr: 'Coûts',
      it: 'Costi',
    },
  },
  otherExpenses: {
    de: 'Übrige Projektkosten',
    fr: 'Autres coûts du projet',
    it: 'Ulteriori costi del progetto',
    tooltip: {
      de: 'Unmittelbar mit dem Projekt zusammenhängende Aufwendungen und Leistungen Dritter.',
      fr: 'Dépenses et prestations de tiers en lien direct avec le projet.',
      it: 'Le spese e le prestazioni di terzi direttamente collegate al progetto.',
    },
    date: {
      de: 'Datum',
      fr: 'Date',
      it: 'Data',
    },
    milestone: {
      de: 'Meilenstein',
      fr: 'Etape',
      it: 'Tappa',
    },
    workPackage: {
      de: 'Arbeitspaket',
      fr: 'Paquet de travaux',
      it: 'Pacchetti di lavoro ',
    },
    expenseType: {
      de: 'Kostenart',
      fr: 'Type de coûts',
      it: 'Tipo dei costi',
    },
    derivation: {
      de: 'Herleitung der Kosten',
      fr: 'Calcul des coûts',
      it: 'Struttura dei costi',
    },
    expenses: {
      de: 'Kosten (CHF)',
      fr: 'Coûts',
      it: 'Costi',
    },
  },
  total: {
    de: 'Total anrechenbare Projektkosten',
    fr: 'Total des coûts de projet imputables',
    it: 'Totale costi computabili del progetto',
    customError: {
      de: 'Bitte fügen Sie mindestens ein Eintrag "Interne Personalkosten" oder "Übrige Projektkosten" hinzu.',
      fr: 'Veuillez ajouter au moins une entrée "Coûts de personnel internes" ou "Autres coûts du projet".',
      it: 'Si prega di aggiungere almeno una voce "Costi interni di personale" o "Ulteriori costi del progetto".',
    },
    tooltip: {
      de: 'Als Gesamtprojektkosten anrechenbar sind nur tatsächlich entstandene und für die zweckmässige Erfüllung des Projekts unbedingt erforderlichen Aufwendungen (vgl. Art. 53 Abs. 3 EnG). Als anrechenbare Projektkosten gelten auch unmittelbar mit dem Projekt zusammenhängende Aufwendungen und Leistungen Dritter.',
      fr: 'Seules sont imputables à titre de coûts totaux de projet les dépenses effectives et absolument nécessaires à l’exécution efficace de celui-ci (cf. art. 53, al. 3, LEne). À titre de coûts de projet imputables sont également prises en compte les dépenses et prestations de tiers en lien direct avec le projet.',
      it: 'Sono considerati costi complessivi computabili del progetto solo le spese effettive assolutamente necessarie all’adempimento efficace del progetto (cfr. art. 53 cpv. 3 LEne). Per costi computabili si intendono anche le spese e le prestazioni di terzi direttamente collegate al progetto.',
    },
  },
  projectIncome: {
    de: 'Projekteinnahmen',
    fr: 'Recettes du projet',
    it: 'Entrate del progetto',
    tooltip: {
      de: 'Es sind sämtliche Finanzierungsquellen offenzulegen.',
      fr: 'Toutes les sources de financement doivent être énumérées.',
      it: 'Vanno indicate tutte le fonti di finanziamento.',
    },
    firstYear: {
      de: 'Kalenderjahr 1 (CHF)',
      fr: 'Année civile 1',
      it: 'Anno civile 1',
    },
    secondYear: {
      de: 'Kalenderjahr 2 (CHF)',
      fr: 'Année civile 2',
      it: 'Anno civile 2',
    },
    thirdYear: {
      de: 'Kalenderjahr 3 (CHF)',
      fr: 'Année civile 3',
      it: 'Anno civile 3',
    },
    fourthYear: {
      de: 'Kalenderjahr 4 (CHF)',
      fr: 'Année civile 4',
      it: 'Anno civile 4',
    },
    total: {
      de: 'Total (CHF)',
      fr: 'Total (CHF)',
      it: 'Totale (CHF)',
    },
  },
  echSubvention: {
    de: 'Beantragte Subvention EnergieSchweiz',
    fr: 'Subvention demandée à SuisseEnergie',
    it: 'Sovvenzione richiesta a SvizzeraEnergia',
    tooltip: {
      de: 'Subventionen können bis 40% der Gesamtprojektkosten gewährt werden.',
      fr: 'Des subventions peuvent être accordées jusqu’à concurrence de 40% des coûts totaux de projet.',
      it: 'Possono essere concesse sovvenzioni fino al 40 per cento dei costi totali del progetto.',
    },
    firstYear: {
      de: 'Kalenderjahr 1 (CHF)',
      fr: 'Année civile 1',
      it: 'Anno civile 1',
    },
    secondYear: {
      de: 'Kalenderjahr 2 (CHF)',
      fr: 'Année civile 2',
      it: 'Anno civile 2',
    },
    thirdYear: {
      de: 'Kalenderjahr 3 (CHF)',
      fr: 'Année civile 3',
      it: 'Anno civile 3',
    },
    fourthYear: {
      de: 'Kalenderjahr 4 (CHF)',
      fr: 'Année civile 4',
      it: 'Anno civile 4',
    },
    percentageOfTotalCosts: {
      de: 'Anteil Subvention ECH an den Gesamtkosten (%)',
      fr: 'Part de la subvention ECH aux coûts totaux (%)',
      it: 'Quota dei sussidi di SvizzeraEnergia rispetto ai costi globali (%)',
    },
    total: {
      de: 'Total (CHF)',
      fr: 'Total (CHF)',
      it: 'Totale (CHF)',
    },
  },
  governmentFunding: {
    de: 'Weitere Bundesmittel',
    fr: 'Autres aides fédérales',
    it: 'Altri contributi federali',
    firstYear: {
      de: 'Kalenderjahr 1 (CHF)',
      fr: 'Année civile 1',
      it: 'Anno civile 1',
    },
    secondYear: {
      de: 'Kalenderjahr 2 (CHF)',
      fr: 'Année civile 2',
      it: 'Anno civile 2',
    },
    thirdYear: {
      de: 'Kalenderjahr 3 (CHF)',
      fr: 'Année civile 3',
      it: 'Anno civile 3',
    },
    fourthYear: {
      de: 'Kalenderjahr 4 (CHF)',
      fr: 'Année civile 4',
      it: 'Anno civile 4',
    },
    origin: {
      de: 'Herkunft der Bundesmittel',
      fr: 'Origine des fonds de la Confédération',
      it: 'Provenienza dei mezzi stanziati dalla Confederazione',
    },
    total: {
      de: 'Total (CHF)',
      fr: 'Total (CHF)',
      it: 'Totale (CHF)',
    },
  },
  furtherFundings: {
    de: 'Weitere Förderbeiträge (Kantone, Gemeinden, Hochschulen, Unternehmen)',
    fr: 'Autres contributions (cantons, communes, hautes écoles, entreprises)',
    it: 'Altri contributi di incentivazione (Cantoni, Comuni, scuole universitarie, aziende)',
    firstYear: {
      de: 'Kalenderjahr 1 (CHF)',
      fr: 'Année civile 1',
      it: 'Anno civile 1',
    },
    secondYear: {
      de: 'Kalenderjahr 2 (CHF)',
      fr: 'Année civile 2',
      it: 'Anno civile 2',
    },
    thirdYear: {
      de: 'Kalenderjahr 3 (CHF)',
      fr: 'Année civile 3',
      it: 'Anno civile 3',
    },
    fourthYear: {
      de: 'Kalenderjahr 4 (CHF)',
      fr: 'Année civile 4',
      it: 'Anno civile 4',
    },
    origin: {
      de: 'Herkunft der Förderbeiträge',
      fr: "Origine des contributions d'encouragement",
      it: 'Provenienza dei contributi di incentivazione',
    },
    total: {
      de: 'Total (CHF)',
      fr: 'Total (CHF)',
      it: 'Totale (CHF)',
    },
  },
  ownResources: {
    de: 'Finanzielle Eigenleistungen',
    fr: 'Prestations financières propres',
    it: 'Prestazioni finanziarie proprie',
    firstYear: {
      de: 'Kalenderjahr 1 (CHF)',
      fr: 'Année civile 1',
      it: 'Anno civile 1',
    },
    secondYear: {
      de: 'Kalenderjahr 2 (CHF)',
      fr: 'Année civile 2',
      it: 'Anno civile 2',
    },
    thirdYear: {
      de: 'Kalenderjahr 3 (CHF)',
      fr: 'Année civile 3',
      it: 'Anno civile 3',
    },
    fourthYear: {
      de: 'Kalenderjahr 4 (CHF)',
      fr: 'Année civile 4',
      it: 'Anno civile 4',
    },
    total: {
      de: 'Total (CHF)',
      fr: 'Total (CHF)',
      it: 'Totale (CHF)',
    },
  },
  unpaidOwnContributions: {
    de: 'Unentgeltliche Eigenleistungen',
    fr: 'Prestations propres non rémunérées',
    it: 'Prestazioni proprie non rimunerate',
    tooltip: {
      de: 'Eigenleistungen können im Antrag entweder nach Aufwand, wobei die Stundensätze pro Funktionsstufe zu nennen sind, oder pauschal berücksichtigt werden. Gemäss Angabe "interne Personalkosten" in diesem Formular.',
      fr: 'Les prestations propres peuvent être prises en compte dans la demande soit en fonction du temps investi, en indiquant le taux horaire par échelon de fonction, soit sur une base forfaitaire. Selon l’indication dans le champ "Coûts de personnel internes" de ce formulaire.',
      it: 'Le prestazioni proprie possono essere considerate nella domanda in base al dispendio di tempo, nel qual caso si deve indicare la tariffa oraria per ogni livello di funzione, oppure su base forfettaria. Come indicato nel campo "Costi interni di personale" di questo modulo.',
    },
    firstYear: {
      de: 'Kalenderjahr 1 (CHF)',
      fr: 'Année civile 1',
      it: 'Anno civile 1',
    },
    secondYear: {
      de: 'Kalenderjahr 2 (CHF)',
      fr: 'Année civile 2',
      it: 'Anno civile 2',
    },
    thirdYear: {
      de: 'Kalenderjahr 3 (CHF)',
      fr: 'Année civile 3',
      it: 'Anno civile 3',
    },
    fourthYear: {
      de: 'Kalenderjahr 4 (CHF)',
      fr: 'Année civile 4',
      it: 'Anno civile 4',
    },
    total: {
      de: 'Total (CHF)',
      fr: 'Total (CHF)',
      it: 'Totale (CHF)',
      customError: {
        de: 'Die unentgeltlichen Eigenleistungen dürfen den Gesamtbetrag der internen Personalkosten nicht übersteigen.',
        fr: 'Prestations propres non rémunérées ne peuvent pas dépasser le montant total des coûts de personnel internes.',
        it: 'I prestazioni proprie non rimunerate non possono superare l’importo totale dei costi interni del personale.',
      },
    },
  },
  thirdPartyContributions: {
    de: 'Unentgeltliche Leistungen Dritter',
    fr: 'Prestations de tiers non rémunérées',
    it: 'Prestazioni di terzi non rimunerate',
    firstYear: {
      de: 'Kalenderjahr 1 (CHF)',
      fr: 'Année civile 1',
      it: 'Anno civile 1',
    },
    secondYear: {
      de: 'Kalenderjahr 2 (CHF)',
      fr: 'Année civile 2',
      it: 'Anno civile 2',
    },
    thirdYear: {
      de: 'Kalenderjahr 3 (CHF)',
      fr: 'Année civile 3',
      it: 'Anno civile 3',
    },
    fourthYear: {
      de: 'Kalenderjahr 4 (CHF)',
      fr: 'Année civile 4',
      it: 'Anno civile 4',
    },
    total: {
      de: 'Total (CHF)',
      fr: 'Total (CHF)',
      it: 'Totale (CHF)',
    },
  },
  restMoney: {
    de: 'Ungedeckter Restbetrag',
    fr: 'Solde non couvert',
    it: 'Saldo scoperto',
  },
  paymentPlan: {
    de: 'Zahlungsplan',
    fr: 'Plan de paiement',
    it: 'Piano di pagamento',
    tooltip: {
      de: 'Daten der Meilensteine / Arbeitspakete und der damit verknüpften Zahlungen.',
      fr: 'Données des étapes / paquets de travaux et des versements correspondants.',
      it: 'Indicazione delle date delle tappe o dei pacchetti di lavoro e dei relativi pagamenti.',
    },
    date: {
      de: 'Datum',
      fr: 'Date',
      it: 'Data',
    },
    description: {
      de: 'Beschreibung/Meilenstein',
      fr: 'Description / étape',
      it: 'Descrizione / tappa',
    },
    amount: {
      de: 'Betrag (CHF)',
      fr: 'Montant',
      it: 'Importo',
    },
  },
  justification: {
    de: 'Begründung der nicht wirtschaftlichen Tragfähigkeit',
    fr: 'Justification de l’absence de viabilité économique',
    it: "Motivazione dell'assenza di viabilità economica",
    tooltip: {
      de: 'Erklärung wieso eine finanzielle Unterstützung erforderlich ist.',
      fr: 'Justification de la nécessité de disposer d’un soutien financier.',
      it: 'Spiegazione dei motivi per cui è necessario un sostegno finanziario.',
    },
  },
  uploads: {
    de: 'Anhänge',
    fr: 'Annexes',
    it: 'Allegati',
    upload: {
      de: 'Anhang',
      fr: 'Annexe',
      it: 'Allegato',
    },
  },
  comments: {
    de: 'Bemerkungen',
    fr: 'Remarques',
    it: 'Commenti',
  },
  errors: {
    collectionMinEntries: {
      de: 'Bitte erfassen Sie mindestens einen Eintrag.',
      fr: 'Veuillez saisir au moins une entrée.',
      it: 'Si prega di inserire almeno una voce.',
    },
    generalFieldError: {
      de: 'Bitte füllen Sie dieses Feld aus!',
      fr: 'Veuillez remplir ce champ !',
      it: 'Si prega di compilare questo campo!',
    },
    invalidEmail: {
      de: 'Ungültige E-Mail Adresse.',
      fr: 'Adresse électronique invalide.',
      it: 'Indirizzo e-mail non valido.',
    },
  },
  sentNote: {
    de: 'Besten Dank. Das Formular wurde eingereicht. Sie erhalten in den nächsten Minuten per E-Mail eine Kopie der Eingangsbestätigung. Falls Sie keine Kopie der Eingangsbestätigung per E-Mail erhalten melden Sie Sich bei energieschweiz@bfe.admin.ch.',
    fr: "Nous vous remercions vivement. Le formulaire a été soumis. Vous recevrez une copie de l'accusé de réception par e-mail dans les prochaines minutes. Si vous ne recevez pas de copie de l'accusé de réception par e-mail, veuillez contacter energieschweiz@bfe.admin.ch.",
    it: 'Grazie mille. Il modulo è stato inviato. Riceverai una copia della conferma di ricezione via e-mail nel prossimi minuti. Se non ricevi una copia della conferma di ricezione via e-mail, contatta energieschweiz@bfe.admin.ch.',
  },
  sentErrorNote: {
    de: 'Beim Senden der Daten ist ein Fehler aufgetreten. Prüfen Sie ihre Internetverbindung und probieren Sie es später nochmals.',
    fr: 'Une erreur est survenue lors de l’envoi des données. Vérifiez votre connexion Internet et réessayez plus tard.',
    it: 'Si è verificato un errore durante l’invio dei dati. Controlla la tua connessione internet e riprova più tardi.',
  },
  uploadErrorNote: {
    de: 'Beim Hochladen der Datei ist ein Fehler aufgetreten. Prüfen Sie ihre Internetverbindung und probieren Sie es später nochmals.',
    fr: 'Une erreur est survenue lors du téléchargement du fichier. Vérifiez votre connexion Internet et réessayez plus tard.',
    it: 'Si è verificato un errore durante il caricamento del file. Controlla la tua connessione internet e riprova più tardi.',
  },
  download: {
    de: 'Download',
    fr: 'Téléchargement',
    it: 'Scaricare',
  },
  dragOr: {
    de: 'Datei hierhin ziehen oder %{browse}',
    fr: 'Faire glisser ou %{browse}',
    it: 'Trascina o %{browse}',
  },
  browse: {
    de: 'auswählen',
    fr: 'sélectionner le fichier ici',
    it: 'seleziona il file qui',
  },
};

export default i18n;
